'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _templateObject = (0, _taggedTemplateLiteral3.default)([''], ['']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SvgMultiElements = require('../SvgMultiElements');

var _SvgMultiElements2 = _interopRequireDefault(_SvgMultiElements);

var _down = require('../../../assets/icons/chevron/down');

var _down2 = _interopRequireDefault(_down);

var _up = require('../../../assets/icons/chevron/up');

var _up2 = _interopRequireDefault(_up);

var _right = require('../../../assets/icons/chevron/right');

var _right2 = _interopRequireDefault(_right);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getConfig = function getConfig(direction) {
  return {
    down: _down2.default,
    up: _up2.default,
    right: _right2.default
  }[direction];
};

var chevronIcon = function chevronIcon(_props) {
  var direction = _props.direction,
      color = _props.color,
      size = _props.size,
      props = (0, _objectWithoutProperties3.default)(_props, ['direction', 'color', 'size']);

  var config = getConfig(direction);
  config.stroke = color;
  config.width = size;
  config.height = size;
  return _react2.default.createElement(_SvgMultiElements2.default, (0, _extends3.default)({}, props, {
    config: config
  }));
};

chevronIcon.propTypes = {
  direction: _propTypes2.default.oneOf(['down', 'up', 'right']),
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

chevronIcon.defaultProps = {
  direction: 'down',
  color: '#6E0AD6',
  size: 24
};

exports.default = (0, _styledComponents2.default)(chevronIcon)(_templateObject);